
export default {
    demo: state => state.demo,
    userInfo: state => state.userInfo,
}